import { getEnvContext } from './envContext';

const titles = {
  peakworkSet: 'Peakwork Set',
  sabreSet: 'Sabre Mosaic\u2122 Vacations',
};

const favIcons = {
  peakworkSet: '/images/favicon-16x16.png',
  sabreSet: '/images/faviconSabre.png',
};

const variables = {
  peakworkSet: {
    '--q-primary': '#00415a',
    '--q-color-primary': '#00415a',
    '--q-secondary': '#009cd2',
    '--q-color-secondary': '#009cd2',
    '--q-accent': '#f0d214',
    '--q-color-accent': '#f0d214',
    '--q-positive': '#3ab14c',
    '--q-color-positive': '#3ab14c',
    '--q-negative': '#d62341',
    '--q-color-negative': '#d62341',
    '--q-info': '#31ccec',
    '--q-color-info': '#31ccec',
    '--q-warning': '#f2c037',
    '--q-color-warning': '#f2c037',
    '--main-bg-color': '#d3dee2',
    '--main-text-color': '#4c4c4c',
    '--main-logo-url': '/images/logo@2x.svg',
  },
  sabreSet: {
    '--q-primary': '#e2553c',
    '--q-color-primary': '#e2553c',
    '--q-secondary': '#741c1c',
    '--q-color-secondary': '#741c1c',
    '--q-accent': '#e7dfc9',
    '--q-color-accent': '#e7dfc9',
    '--q-positive': '#28864c',
    '--q-color-positive': '#28864c',
    '--q-negative': '#bc302a',
    '--q-color-negative': '#bc302a',
    '--q-info': '#434343',
    '--q-color-info': '#434343',
    '--q-warning': '#f38836',
    '--q-color-warning': '#f38836',
    '--main-bg-color': '#f3efe4',
    '--main-text-color': '#121315',
    '--main-logo-url': '/images/sv-logo.svg',
  },
};

function setTitle(title) {
  document.title = title;
}

function setFavIcon(icon) {
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.getElementsByTagName('head')[0].appendChild(link);
  }
  link.href = icon;
}

function setDefaultVariables(vars) {
  Object.entries(vars).forEach(([varName, varValue]) => {
    document.body.style.setProperty(varName, varValue);
  });
}

export default function setUpEnvContextConfig() {
  const envContext = getEnvContext();
  setTitle(titles[envContext]);
  setFavIcon(favIcons[envContext]);
  setDefaultVariables(variables[envContext]);
}
